import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { SidebarService, ModalService } from '@ibe/services/ui';
import { Router } from '@angular/router';
import { BehaviorSubject, isObservable, Subscription } from 'rxjs';
import { DiscardModalComponent } from '../passengers-discard-modal/discard-modal.component';
import scrollLock from 'scroll-lock';

@Component({
	selector: 'app-sidebar-header',
	templateUrl: './sidebar-header.indra.component.html',
	styleUrls: ['./sidebar-header.component.scss']
})
export class INDRASidebarHeaderComponent implements OnInit, OnDestroy, AfterViewInit  {

	htmlElement = document.getElementsByTagName('html');

	constructor(
		protected sidebarService: SidebarService,
		protected router: Router,
		private modalService: ModalService
	) {
	}

	@Input()
	title;
	
	@Input()
	departureCity;

	@Input()
	arrivalCity;

	@Input()
	label;

	@Input()
	confirmation = false;

	@Input()
	confirmation$ = new BehaviorSubject(false);

	@Input()
	confirmation_message = 'Are you sure you want to close?';

	@Input()
	label_image;

	@Input()
	show_custom_button = false;
	
	// @Input()
	// subTitle; // from phase 1 (not merged)
	
	// @Input() forceClose = false; // from phase 1 (not merged)
	
	// @Output()
	// onClose: EventEmitter<any> = new EventEmitter<any>(); // from phase 1 (not merged)

	allSubscriptions: Subscription[] = [];
	confirmationSubscription: Subscription;

	ngOnInit() {
		//if (this.confirmation$ && isObservable(this.confirmation$)) {
		//	this.confirmation$.subscribe(value => {
		//		this.confirmation = value;
		//	});
		//}
		
		/* note: client change from sprint 7 merge
		this.sidebarService.confirmation = (error, response) => {

			if (response && this.confirmation === true) {
				this.modalService.assignComponent(DiscardModalComponent, {
					handleClose: (err, res) => {
						if (res) this.sidebarService.close();
					}
				});
				this.modalService.open();
			} else {
				this.sidebarService.close();
			}
		};
		*/
	}
	
	ngAfterViewInit() {
		if (this.confirmation$ && isObservable(this.confirmation$)) {
			this.confirmationSubscription = this.confirmation$.subscribe(value => {
				this.confirmation = value;
			});
		}
		this.allSubscriptions.push(this.confirmationSubscription);
	}
	
	INDRA_printSidebarTitleDeparture() {
		return this.departureCity;
	}
	INDRA_printSidebarTitleArrival() {
		return this.arrivalCity;
	}
	
	INDRA_printTitle() {
		return this.title;
	}
	
	INDRA_hasSidebarLabel() {
		return this.label !== undefined;
	}
	
	INDRA_printSidebarLabel() {
		return this.label;
	}
	
	INDRA_hasSidebarLabelImage() {
		return this.label_image !== undefined;
	}
	
	INDRA_printSidebarLabelImage() {
		return this.label_image;
	}

	// not used?
	INDRA_printSidebarTitle() {
		return this.title;
	}

	/** Close sidebar and clear secondary route */
	INDRA_handleClose() {
		this.sidebarService.closeSidebar();
	}
	
	/*  // method from phase 1 (not merged)
	TAP_handleClose() {
		if (this.forceClose) {
			this.onClose.emit();
			setTimeout(() => this.sidebarService.closeSidebar());
		}
		if (this.confirmation) {
			if (confirm(this.confirmation_message)) {
				this.onClose.emit();
				setTimeout(() => this.sidebarService.previousSidebar());
			}
		} else {
			this.onClose.emit();
			setTimeout(() => this.sidebarService.previousSidebar());
		}
	} */
	
	ngOnDestroy() {
		for (let sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}
}
